/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default function OurClients({ data }) {
  return (
    <Fade bottom>
      <section className="container mx-auto py-20">
        <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">Our Clientele</h1>

        <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Our clientele speaks for us. Many prominent brands in various industries
          including Automobile, Hospitality & Tourism, Financial Services, Media &
          Entertainment, Healthcare, and many more have entrusted us with our cutting-edge
          solutions.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-6 px-4">
          {
            data.map((item, index) => (
              <Fade bottom delay={200 * index}>
                <div className="bg-white group rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:scale-110 hover:shadow-xl flex items-center justify-center h-32">
                  <img src={item.imageUrl} alt={item.name} className="max-w-full max-h-20 object-contain filter grayscale hover:grayscale-0 transition-all duration-300" />
                </div>
              </Fade>
            ))
          }
        </div>

      </section>
    </Fade>
  );
}
